import BaseService from "@/boot/BaseService";
class VendedorService extends BaseService {
  constructor() {
    super(null, "/vendedores");
  }
  async index(search) {
    return await this.get("/", { search });
  }
}

export default new VendedorService();
